<template>
      <div @click.stop="">
              <div v-if="deliveryNote.line_unload_records.length > 0 || deliveryNote.point_unload_records.length > 0" class="nopads">
                  <span v-if="deliveryNote.line_unload_records.length > 0" class="span-title show-print" hidden>
                    {{ $t('contract_reports.unload_records.title') }}
                  </span>

                  <div class="trip-results mb-2" style="height:40vh !important; position: relative" @click.stop="">
                      <!-- Map for showing trip here -->
                      <map-container
                          ref="mapContainer"
                          :find-user="false"
                          @onMapChanged="mapChanged"
                      />
                      <trip-map
                          v-if="map"
                          ref="tripMap"
                          :trip-results="trips"
                          :map="map"
                      />
                  </div>

                  <line-unload-record-table v-if="deliveryNote.line_unload_records.length > 0" :records="deliveryNote.line_unload_records"/>
                  <span v-if="deliveryNote.point_unload_records.length > 0" class="item-detail-title mt-4">
                      {{ $t('contract_reports.unload_records.point_unload_records') }}
                  </span>
                  <point-unload-record-table v-if="deliveryNote.point_unload_records.length > 0" :records="deliveryNote.point_unload_records" :dark-header="true"/>
              </div>
              <div v-else class="p-1">
                  <span class="italic">
                    {{ $t('contract_reports.unload_records.no_records') }}
                  </span>
              </div>
          </div>
</template>

<script>
import {timeUtils} from "@/components/mixins/TimeUtils";
import LineUnloadRecordTable from "@/components/contractreport/LineUnloadRecordTable";
import PointUnloadRecordTable from "@/components/contractreport/PointUnloadRecordTable";
import {restApi} from "@/components/mixins/RestApiMixin";
import {downloadHelper} from "@/components/mixins/DownloadMixin";
import {inject} from "vue";
import BaseModal from "@/components/BaseModal";
import MapContainer from "@/components/map/MapContainer";
import TripMap from "@/components/trip/TripMap";

export default {
    name: "ContractReportUnloads",
    components: {
        TripMap,
        MapContainer,
        BaseModal,
        LineUnloadRecordTable,
        PointUnloadRecordTable,
    },
    mixins: [timeUtils, restApi, downloadHelper],
    props: {
        deliveryNote: {
            type: Object,
            required: true
        }
    },
    data: function () {
        return {
            map: null,
            trips: [],
            fields: [
                {field: "date", title: this.$t('delivery_note.date'), sort: true, headerClass: 'routa-table-header'},
                {field: "id", title: this.$t('common.id'), sort: true, headerClass: 'routa-table-header'},
                {field: "vehicle", title: this.$t('delivery_note.vehicle'), sort: true, headerClass: 'routa-table-header'},
                {field: "company", title: this.$t('daily_summary.company'), sort: true, headerClass: 'routa-table-header'},
                {field: "material", title: this.$t('delivery_note.material'), sort: true, headerClass: 'routa-table-header'},
                {field: "type_test_code", title: this.$t('material_station.material.type_test_code'), sort: true, headerClass: 'routa-table-header'},
                {field: "station", title: this.$t('material_station.title'), sort: true, headerClass: 'routa-table-header'},
                {field: "station_company", title: this.$t('material_station.station_owner'), sort: true, headerClass: 'routa-table-header'},
                {field: "amount", title: this.$t('delivery_note.amount'), sort: true, headerClass: 'routa-table-header'},
                {field: "unit", title: this.$t('delivery_note.unit'), sort: false, headerClass: 'routa-table-header'},
            ],
            loading: false
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    mounted() {

    },
    methods: {
        mapChanged(map) {
            this.map = map
            if (map) {
                this.loadTrips()
            }
        },
        getMaterialName(item) {
            return item.station_material ?
                item.station_material.material.name + " (" + (item.station_material.type_test_code) + ")" :
                item.storage_material ? item.storage_material.name :
                    item.manually_added_material ? item.manually_added_material.material : ''
        },
        getStationName(item) {
            return item.station_material ?
                item.station_material.station.name :
                item.storage_material ? item.storage_material.storage.name : ''
        },

        fetchLineUnloadRecordTrips(params) {
            return this.axios.get(this.tripUrl + '/' + 'unloadrecords', {params})
        },

        async loadTrips() {
            this.loading = true
            let date = {}
            let dates = []
            if(this.deliveryNote && this.deliveryNote.line_unload_records.length > 0) {
                for (let i = 0; i < this.deliveryNote.line_unload_records.length; i++) {
                    const record = this.deliveryNote.line_unload_records[i]
                    if(record.start_time && record.end_time) {
                        dates.push({
                            start_time: record.start_time,
                            end_time: record.end_time,
                            vehicle: record.vehicle.id,
                            order: record.order_id
                        })
                    }
                }
                // Backup solution, if unload records do not have vehicle
                date.vehicle_id = this.deliveryNote.vehicle.id
                date.order = this.deliveryNote.order.id
            }
            date.dates = dates
            this.loading++;
            const { data, err } = await this.fetchLineUnloadRecordTrips(date).catch((err) => ({err}));
            this.loading--;
            if (err) {
                this.trips = []
                if (err.response.status && err.response.status === 500) {
                    this.showAlert(this.$t('trip_list.err_too_much'))
                } else {
                    this.showAlert(this.$t('trip_list.err_general'))
                }
                return;
            }
            this.trips = data ? data.map((trip) => {
                // Ensure times will have timezone information. If not, then set as UTC!
                trip.start_time = this.setTime(trip.start_time)
                trip.end_time = this.setTime(trip.end_time)
                return trip;
            }) : []
            if (this.trips && this.trips.length > 0) {
                this.showMap = true
            } else {
                this.showAlert(this.$t('trip_list.no_trips_found'))
            }
            this.loading = false
        }
    }
}
</script>
<style scoped>
</style>
